import React from 'react'
import classNames from 'classnames';

import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import ReactTooltip from 'react-tooltip'

const timeOptions = [{
        value: "Year",
        label: "Year"
    }, {
        value: "SL",
        label: "Start/Length"
    }, {
        value: "SE",
        label: "Start/End"
    }]

const TimeOption = props => (
    <div className="form-input-container">
        <b>Time Input Option: </b>
        <TextField
            select
            style={{width: '194px', paddingLeft: '20px'}}
            label=""
            name="timeOption"
            data-tip data-for='timeOption'
            value={props.timeOption}
            onChange={props.handleInputChange}>

            {timeOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>

        <ReactTooltip id='timeOption' place="right" type="light" effect="solid">
                <div key='timeOption3'><b>NOTE</b> Start time is assumed to be the release time.</div>
                <div key='timeOption0'><b>YEAR:</b> Runs a full year, only input the year in "RUN YEAR".</div>
                <div key='timeOption1'><b>Start/Length:</b> Runs the model for a selected number of hours from the start date and number of hours provided.</div>
                <div key='timeOption2'><b>Start/End:</b> Runs the model for a selected date/time range provided.</div>
        </ReactTooltip>


        {props.timeOption === "SL" ? showSLvars(props) : null }
        {props.timeOption === "SE" ? showSEvars(props) : null }
        {props.timeOption === "Year" ? showYEARvars(props) : null }

    </div>

)

function showSLvars(props){
    return (
        <div className="form-input-container">
            <FormControl className={classNames(props.classes.margin, props.classes.formControl)}
                data-tip data-for="sdate">
                <InputLabel shrink>Start Date</InputLabel>
                <Input
                    inputProps={{ min: "2010010100", max: "2030010100", step: "1" }}
                    type="number"
                    label=""
                    name="sdate"
                    value={props.sdate}
                    onChange={props.handleInputChange}
                    placeholder='Example: 2017040100'
                />
            </FormControl>
            <ReactTooltip id='sdate' place="bottom" type="light" effect="solid">
                <div>
                    Format: YYYYMMDDHH (local hour)
                </div>
            </ReactTooltip>

            <FormControl className={classNames(props.classes.margin, props.classes.formControl)}
                data-tip data-for="runHours">
                <InputLabel shrink>Run Hours</InputLabel>
                <Input
                    inputProps={{ min: "6", max: "43800", step: "1" }}
                    type="number"
                    label=""
                    name="runHours"
                    value={props.runHours}
                    onChange={props.handleInputChange}
                    placeholder='Example: 192'
                />
            </FormControl>
            <ReactTooltip id='runHours' place="bottom" type="light" effect="solid">
                <div>
                    Number of hours to run the model from the start date.
                </div>
            </ReactTooltip>
        </div>
    )
}

function showSEvars(props){
    return (
        <div className="form-input-container">
            <FormControl className={classNames(props.classes.margin, props.classes.formControl)}
                data-tip data-for="sdate">
                <InputLabel shrink>Start Date</InputLabel>
                <Input
                    inputProps={{ min: "2010010100", max: "2030010100", step: "1" }}
                    type="number"
                    label=""
                    name="sdate"
                    value={props.sdate}
                    onChange={props.handleInputChange}
                    placeholder='Example: 2017040100'
                />
            </FormControl>
            <ReactTooltip id='sdate' place="bottom" type="light" effect="solid">
                <div>
                    Format: YYYYMMDDHH (local hour)
                </div>
            </ReactTooltip>
            <FormControl className={classNames(props.classes.margin, props.classes.formControl)}
                data-tip data-for="edate">
                <InputLabel shrink>End Date</InputLabel>
                <Input
                    inputProps={{ min: "2010010100", max: "2030010100", step: "1" }}
                    type="number"
                    label=""
                    name="edate"
                    value={props.edate}
                    onChange={props.handleInputChange}
                    placeholder='Example: 2017043000'
                />
            </FormControl>
            <ReactTooltip id='edate' place="bottom" type="light" effect="solid">
                <div>
                    Format: YYYYMMDDHH (local hour)
                </div>
            </ReactTooltip>
            </div>
        )
    }

function showYEARvars(props){
    return (
        <div className="form-input-container">
            <FormControl className={classNames(props.classes.margin, props.classes.formControl)}
                data-tip data-for="runYear">
                <InputLabel shrink>Run Year</InputLabel>
                <Input
                    inputProps={{ min: "2000", max: "2030", step: "1" }}
                    type="number"
                    label=""
                    name="runYear"
                    value={props.runYear}
                    onChange={props.handleInputChange}
                    placeholder='Example: 2017'
                />
            </FormControl>
            <ReactTooltip id='runYear' place="bottom" type="light" effect="solid">
                <div>
                    For Time Input Option: Year, enter the year to run (YYYY).
                </div>
            </ReactTooltip>
            </div>
        )
    }

export default TimeOption;
